import React, { Component } from 'react'
import ReactGA from 'react-ga'
import styled from 'styled-components'

import './components/styled-components/global.js'
import Head from './components/Head'
import Header from './components/Header'
import Cover from './components/Cover'
import Footer from './components/Footer'


ReactGA.initialize('UA-54127697-3')
ReactGA.pageview(window.location.pathname + window.location.search)

const Container = styled.div`
  @media(max-width: 680px) {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`

class App extends Component {

  constructor (props) {
    super(props)
    
    this.state = {
      loaded: false
    }
  }

  componentDidMount() {
    this.setState({
      loaded: true
    })
  }

  render() {
    return (
      <React.Fragment>
        <Head />
        <Container>
          <Header loaded={this.state.loaded} />
          <Cover loaded={this.state.loaded} />
          <Footer loaded={this.state.loaded} />
        </Container>
      </React.Fragment>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js